module.exports = __webpack_public_path__ + "static/img/jumper_mf_20-1.41ddf03.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/jumper_mf_20-1.svg
// module id = ocMg
// module chunks = 0